import ZoneGisementsController from './zone.gisements.controller';

export default {
    template: require('./zone.gisements.tpl.html'),
    controller: ZoneGisementsController
};
